var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('confirm',{attrs:{"isTwoOpe":true,"message":"是否已支付成功？","is-show":_vm.isShowConfirm,"btn":_vm.btnText},on:{"no-click":_vm.closeConfirm,"yes-click":_vm.yesClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }